import {useState} from "react";
import {useToaster} from "@web-libs/features/toaster/use-toaster";
import {AppointmentInvitation} from "@web-libs/features/appointments/domain/appointment.types";
import {useRepositories} from "@web-libs/core/repositories/application/repository-concerns";
import {DictionaryEntries} from "@web-libs/core/internationalization/dictionary.types";
import {useDictionaryContext} from "@web-libs/core/internationalization/dictionary.context";

export const useInvitationProcessor = (onSuccess: (invitation:AppointmentInvitation) => void) => {
    const {getRepo} = useRepositories()
    const appointmentRepo = getRepo('AppointmentRepository')
    const [isProcessingInvitation, setIsProcessingInvitation] = useState<boolean>(false);
    const toaster = useToaster()
    const toastDict = useDictionaryContext().toast

    const _handleSuccess = (invitation: AppointmentInvitation, message: string) => {
        toaster.success(message);
        onSuccess(invitation);
    }

    const _handleError = (error: any) => {
        if(error?.status == 422){
            toaster.error(toastDict.appointmentFullyBooked, "invitation-error");
        }else {
            toaster.error(toastDict.notWorked, "invitation-error");
        }
        throw error;
    }
    const processInvitation = async (invitation: AppointmentInvitation, action: (invitation: AppointmentInvitation) => Promise<void>, message: string) => {
        setIsProcessingInvitation(true);
        try {
            await action(invitation);
            _handleSuccess(invitation, message);
        } catch (error) {
            _handleError(error);
        } finally {
            setIsProcessingInvitation(false);
        }
    }

    const acceptInvitation = async (invitation: AppointmentInvitation) => {
        await processInvitation(invitation, appointmentRepo.acceptInvitation, toastDict.invitationAccepted);
    }

    const declineInvitation = async (invitation: AppointmentInvitation) => {
        await processInvitation(invitation, appointmentRepo.declineInvitation, toastDict.invitationDeclined);
    }

    return {
        acceptInvitation,
        declineInvitation,
        isProcessingInvitation
    }
}
